import { AuthStateType } from "../../UserReducer"
import { ActionType } from "../../Actions"
import { SET_PARAMETERS_OPENING } from "../../Actions/Auth/setParametersOpeningAction";

export default function parametersOpeningReducer (state: AuthStateType, action: ActionType): AuthStateType {

    if (action?.type === SET_PARAMETERS_OPENING){
        return {
            ...state,
            canOpenParametersUntil: action.payload
        }
    }

    return state;
}